export default class initObserver {
  constructor() {
    const elem = document.querySelectorAll('.js-observedItem');
    const options = {
      rootMargin: '-30% 0px',
    };

    const setVisible = (target) => {
      target.classList.add('visible');
    };

    const observeUse = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setVisible(entry.target);
        }
      });
    };

    const observer = new IntersectionObserver(observeUse, options);
    elem.forEach(iSObserver => {
      observer.observe(iSObserver);
    });


    // hide header when scrolling down
    var beforePos = 0;

    function ScrollAnime() {
      var scroll = $(window).scrollTop();
      if ( 70 > scroll || 0 > scroll - beforePos ){
        $('#header').removeClass('is-hidden');
      } else {
        $('#header').addClass('is-hidden');
      }
      beforePos = scroll;
    }

    $(window).scroll(function () {
      ScrollAnime();
    });

    $(window).on('load', function () {
      ScrollAnime();
    });

  }
}
